// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1kyEX","notes":"Notes_notes__1qBAi","note":"Notes_note__1zRWt","markdown":"Notes_markdown__ucjbv"};